import {getCookie, setCookie} from 'common/util/cookie';

export function setTrackingCookies(): void {
  const items = getTrackingRules();

  for (const item of items) {
    const cookieName = getCookieName(item);

    if (!getCookie(cookieName)) {
      setCookie(cookieName, getTrackingValue(item).substring(0, 254), 365, true);
    }
  }
}

function getCookieName(item): string {
  return `mixpanel_` + item.tag;
}

function getTrackingRules() {
  return [
    {
      tag: `utm_medium`,
      social: `social`,
      seo: `organic`,
      noReferrer: `direct`,
      default: `weblink`,
      marketo: `Last_Touch_Medium__c`,
    },
    {
      tag: `utm_source`,
      social: getDomain(),
      seo: getDomain(),
      noReferrer: `mixpanel`,
      default: getDomain(),
      marketo: `Last_Touch_Source__c`,
    },
    {
      tag: `utm_campaign`,
      marketo: `Last_Touch_Campaign__c`,
      social: getReferrer(),
      seo: window.location.href,
      noReferrer: window.location.href,
      default: getReferrer(),
    },
    {
      tag: `utm_content`,
      social: getReferrer(),
      seo: window.location.origin,
      noReferrer: window.location.origin,
      default: window.location.origin,
      marketo: `Last_Touch_Content__c`,
    },
    {
      tag: `utm_term`,
      social: `na`,
      seo: `na`,
      noReferrer: `na`,
      default: `na`,
      marketo: `Last_Touch_Keyword__c`,
    },
  ];
}

function getTrackingValue(item) {
  if (getUrlParameter(item.tag)) {
    return getUrlParameter(item.tag);
  }

  if (getReferrer()) {
    if (isSEO()) {
      return item.seo;
    }

    if (isSocial()) {
      return item.social;
    }

    if (isMixpanel() && item.tag === `utm_medium`) {
      return `direct`;
    }

    return item.default;
  }

  return item.noReferrer;
}

function getReferrer(): string | false {
  const referrer = document.referrer;
  if (referrer !== `` && referrer !== undefined && referrer !== null) {
    return referrer;
  }

  return false;
}

function isSEO(): boolean {
  const domains = [
    `google.com`,
    `www.google.com`,
    `yahoo.com`,
    `www.yahoo.com`,
    `bing.com`,
    `www.bing.com`,
    `www.baidu.com`,
    `baidu.com`,
  ];

  /* let's add a partial match for google domains */
  const domain = getDomain();
  if (domain && domain.includes(`www.google`)) {
    return true;
  }

  return domain && domains.includes(domain);
}

function isSocial(): boolean {
  const domains = [
    `plus.google.com`,
    `www.facebook.com`,
    `facebook.com`,
    `www.linkedin.com`,
    `linkedin.com`,
    `www.twitter.com`,
    `twitter.com`,
    `youtube.com`,
    `www.youtube.com`,
    `t.co`,
  ];
  const domain = getDomain();
  return domain && domains.includes(domain);
}

function isMixpanel(): boolean {
  const domain = getDomain();
  return domain && domain.includes(`mixpanel.com`);
}

function getDomain(): string | false {
  const referrer = getReferrer();
  return referrer ? referrer.split(`/`)[2] : false;
}

function getUrlParameter(key): string | false {
  const params = getUrlParameters();
  return key in params ? params[key] : false;
}

function getUrlParameters() {
  const search = window.location.search.substring(1);
  if (search) {
    return JSON.parse(`{"` + search.replace(/&/g, `","`).replace(/=/g, `":"`) + `"}`, function (key, value) {
      return key === `` ? value : decodeURIComponent(value);
    });
  }
  return {};
}
